// E2E punch-list — IMG-stream-first program-picker ordering. Pure, deterministic: programs whose OWN `stream`
// field matches the CV's stream come first, then everything else — stable within each group (never reorders
// two programs that were already adjacent and in the same group), so this is a pure grouping re-sort, not a
// content change. A CV with no stream ('' | null | 'cmg' with no cmg-tagged programs, etc.) is a no-op — the
// original relative order is preserved exactly.
export interface StreamSortable { stream: string | null }

export function sortProgramsStreamFirst<T extends StreamSortable>(programs: T[], cvStream: string | null | undefined): T[] {
  if (!cvStream) return programs; // no known stream — nothing to prioritize, leave order untouched
  // Stable partition: Array.prototype.sort in modern JS engines (V8/spidermonkey/JSC) is a STABLE sort, so a
  // comparator that only distinguishes "matches" vs "doesn't" preserves each group's original relative order.
  return [...programs].sort((a, b) => {
    const aMatch = a.stream === cvStream ? 0 : 1;
    const bMatch = b.stream === cvStream ? 0 : 1;
    return aMatch - bMatch;
  });
}
